import toast from 'react-hot-toast';
import useApi from '../useApi';
import { ICopyFileReq, ICopyFileRes } from './index.type';

const useCutFile = () => {
  const { loading: cutFileLoading, makeApiCall } = useApi({
    url: `/fileExchange/cut`,
    method: 'POST',
  });

  const cutFile = async (formData: ICopyFileReq) => {
    const { response, error } = await makeApiCall<ICopyFileReq, ICopyFileRes>(formData);
    if (response?.status === 'success') {
      toast.success('File copied!');
      return response;
    }

    if (response?.status === 'fail') return { status: response?.status };
    if (error) toast.error(error?.msg || 'Failed to move file. Please try again.');
  };

  return {
    cutFile,
    cutFileLoading,
  };
};

export default useCutFile;
